'use client'

import type { ElementType, ReactNode } from 'react'
import { Icons } from '@/components/ui/icons'
import type { PageId } from '@/lib/access'
import { labelForPage } from '@/lib/navigation'
import { PageHeader } from '@/components/shell/PageHeader'
import { RequirePage } from '@/components/shell/RequirePage'

/** An icon by its key in `Icons`, so server pages can name one (a component cannot cross to the client). */
export type IconName = Exclude<keyof typeof Icons, 'brandStyle'>

/**
 * L0 route stub: the page guard, the page header and a placeholder card. The
 * lane that owns the route replaces the whole page file.
 */
export function BeingBuilt({
  id,
  title,
  subtitle,
  icon,
  children,
}: {
  id: PageId
  title?: string
  subtitle?: string
  icon?: IconName
  children?: ReactNode
}) {
  const glyph: ElementType | undefined = icon ? Icons[icon] : undefined
  return (
    <RequirePage id={id}>
      <PageHeader title={title ?? labelForPage(id)} subtitle={subtitle} icon={glyph} />
      {children}
      <div className='rounded-2xl border border-hairline bg-card p-8 text-sm text-muted-foreground shadow-soft'>
        Being built.
      </div>
    </RequirePage>
  )
}
